/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import EventStageDescription from 'ui/components/blocks/EventStageDescription.vue';

/**
 * This component is used to display information about the current stage of event
 * @exports EventStageInfo
 */
const __vue_script__ = {
    name: 'EventStageInfo',

    components: { ExpandableContent, EventStageDescription },

    props: {
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        const stage = this.event.lifecycle?.stage;
        return {
            stage,
            isProduction: stage === 'production',
            isOpen: false,
            environment: this.$utils.workspaces.getWorkspaceEnvironment(this.event)
        };
    },

    methods: {
        getSettingsLinks() {
            const settingsModule = this.$services.blueprint.getModuleByName('eventSettings');
            return this.$utils.modules.getRouteHref(settingsModule, 'general', { eventId: this.event._id });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-stage-info",class:[_vm.stage]},[_c('expandable-content',{staticClass:"accordion-item",attrs:{"clickable-header":true,"slim":true,"is-open":_vm.isOpen,"togglerText":"event_stages.more_info","openTogglerText":"event_stages.less_info","animated":true},on:{"toggle":function($event){_vm.isOpen = !_vm.isOpen}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"header-icon"},[_c('i',{staticClass:"ic-calendar-agenda"})]),_c('div',{staticClass:"header-text"},[_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('event_stages.info_title'))+": ")]),_c('span',{staticClass:"stage"},[_vm._v(_vm._s(_vm.$utils.strings.capitalize(_vm.environment)))])])]},proxy:true}])},[[_c('event-stage-description',{attrs:{"stage":_vm.stage}}),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"links"},[_c('a',{attrs:{"href":_vm.$utils.links.getLinkUrl('event_status'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('event_stages.discover_more')))])]),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"btn",class:{ 'btn-primary': _vm.isProduction, 'btn-default': !_vm.isProduction },attrs:{"href":_vm.getSettingsLinks()}},[_vm._v(_vm._s(_vm.$t('event_stages.change_status')))])])])]],2)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventStageInfo.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__